import Div from '@jumbo/shared/Div'
import { Autocomplete, Box, TextField } from '@mui/material'
import { BranchFormContext } from 'app/pages/MyBranches/AddEditOfflineStore'
import { Form, Formik } from 'formik'
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import * as yup from "yup"

const disabledStyling = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#475259",
    },
    "& .MuiInputLabel-root": {
        color: "#475259", // Change label color to blue
    },
};

const AddBranch = ({formikRef}) => {
    const {id} = useParams()
    const {branchProps:{companyId,data,setData}} = useContext(BranchFormContext);
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    offlinestoreId: companyId,
                    branch_name: data?.branch_name,
                    branch_onboarding_date: data?.branch_onboarding_date
                }}
                validationSchema={
                    yup.object({
                        branch_name: yup.string().required('Branch Name is required'),
                        branch_onboarding_date: yup.date().required('Date is required'),
                    })
                }
                onSubmit={(values) => {
                    setData((pre) => ({ ...pre, branch_name: values.branch_name, branch_onboarding_date: values.branch_onboarding_date }))
                }}
                innerRef={formikRef}
            >
                {({ values, handleChange, errors, setFieldValue,touched, handleBlur}) => {
                    return (
                        <Div sx={{ marginTop: "2%" }}>
                            <Form>
                                <Div sx={{
                                    display: "flex",
                                    width: "100%",
                                    flexWrap: "wrap",
                                    columnGap: 2,
                                }}>
                                    {/* <Autocomplete
                                        disabled={(companyId?._id) ? true : false}
                                        sx={{ width: "30%",...disabledStyling }}
                                        size="small"
                                        id="company-autocomplete"
                                        options={companyDropdown || []}
                                        value={companyId}
                                        label="Supplier"
                                        freeSolo
                                        getOptionLabel={(option) => option?.company_name}
                                        isOptionEqualToValue={(option, value) => option?._id === value._id}
                                        onChange={(e, newValue) => {
                                            setCompanyId(newValue)
                                            setFieldValue("offlinestoreId",newValue?._id)
                                        }}
                                        onBlur={handleBlur}
                                        renderOption={(props, option) => (
                                            <Box
                                                component="li"
                                                sx={{ textTransform:"capitalize" }}
                                                {...props}
                                                key={option?._id}
                                            >
                                                {`${option?.company_name} `}{option?.pan_no && `(${option?.pan_no})`}
                                            </Box>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label={`offlinestoreId Name`} 
                                            required name={"offlinestoreId"}
                                             error={errors?.offlinestoreId && touched?.offlinestoreId} helperText={errors?.offlinestoreId && touched?.offlinestoreId ? errors?.offlinestoreId?._id : ""}
                                            />
                                        )}
                                    /> */}
                                    <TextField name="branch_name" required value={values.branch_name} label="Branch Name" size="small" sx={{ width: "30%" }} onChange={handleChange} onBlur={handleBlur} error={errors?.branch_name && touched?.branch_name} helperText={errors?.branch_name && touched?.branch_name ? errors?.branch_name : ""} />

                                    <TextField name="branch_onboarding_date" type="date" required value={values.branch_onboarding_date} label="OnBoarding Date" size="small" sx={{ width: "30%" }} onChange={handleChange} onBlur={handleBlur} error={errors?.branch_onboarding_date && touched?.branch_onboarding_date} helperText={errors?.branch_onboarding_date && touched?.branch_onboarding_date ? errors?.branch_onboarding_date : ""} />
                                </Div>
                            </Form>
                        </Div>
                    )
                }}
            </Formik>
        </>
    )
}

export default React.memo(AddBranch)